import { createAction, createSlice } from '@reduxjs/toolkit';
import { CollateralHistoryDetailRecord, CollateralHistoryViewRecord, CoreMsgTypes } from '@tassat/fred-definitions';

interface PledgesState {
    pledges: {
        [id: string]: CollateralHistoryViewRecord;
    };
    pledgeDetail: CollateralHistoryDetailRecord | null;
    haltRealtimePledges: boolean;
}

const initialState: PledgesState = {
    pledges: {},
    pledgeDetail: null,
    haltRealtimePledges: false
};

const setPledgesAction = createAction<CollateralHistoryViewRecord[]>('SET_PLEDGES');
const collateralHistoryViewRecordAction = createAction<CollateralHistoryViewRecord>(CoreMsgTypes.CollateralHistoryViewRecord);
const setPledgeDetailAction = createAction<CollateralHistoryDetailRecord>('SET_PLEDGE_DETAIL');
const resetPledgeDetailAction = createAction('RESET_PLEDGE_DETAIL');
const collateralHistoryDetailRecordAction = createAction<CollateralHistoryDetailRecord>(CoreMsgTypes.CollateralHistoryDetailRecord);
const haltRealtimePledgesAction = createAction('HALT_REALTIME_PLEDGES');
const resumeRealtimePledgesAction = createAction('RESUME_REALTIME_PLEDGES');

const pledgesSlice = createSlice({
    name: 'pledges',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(setPledgesAction, (state, action) => {
                const mappedPledges = {};
                action.payload.forEach((pledge) => {
                    mappedPledges[pledge.PledgeId] = pledge;
                });

                state.pledges = mappedPledges;
            })
            .addCase(collateralHistoryViewRecordAction, (state, action) => {
                const reducerId = action.payload.PledgeId;
                if (state.haltRealtimePledges && !state.pledges[reducerId]) {
                    return state;
                }

                if (!state.pledges[reducerId]) {
                    state.pledges[reducerId] = action.payload;
                } else {
                    Object.assign(state.pledges[reducerId], action.payload);
                }
            })
            .addCase(setPledgeDetailAction, (state, action) => {
                state.pledgeDetail = action.payload;
            })
            .addCase(resetPledgeDetailAction, (state) => {
                state.pledgeDetail = null;
            })
            .addCase(collateralHistoryDetailRecordAction, (state, action) => {
                if (state.pledgeDetail?.PledgeId && state.pledgeDetail.PledgeId === action.payload.PledgeId) {
                    Object.assign(state.pledgeDetail, action.payload);
                }
            })
            .addCase(haltRealtimePledgesAction, (state) => {
                state.haltRealtimePledges = true;
            })
            .addCase(resumeRealtimePledgesAction, (state) => {
                state.haltRealtimePledges = false;
            });
    }
});

export default pledgesSlice.reducer;